import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { type FlexProps, Flex } from 'antd';

export const Card = styled.div`
  width: 100%;
  max-width: 600px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.strokeDarkGrey};
  box-shadow: 0 3px 8px 0 ${({ theme }) => rgba(theme.colors.dark, 0.1)};
  border-radius: 10px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
`;

export const Inner = styled(Flex)<FlexProps>`
  padding: 20px 30px 30px 30px;
`;
